import _ from 'lodash';
import { PREFERRED_CONTACT_METHODS } from '../../constants/constants';

export default (language, phoneType) => PREFERRED_CONTACT_METHODS[language].options.map(option => {
	return _.extend({}, option, { enabled: phoneType === 'mobile' || option.value !== 'sms' });
});
